import type { PeriodSummaryMode } from "@/pages/human-resources/time-management/business/analysis/PeriodSummaryMode.ts";
import type { CalendarDay } from "@/pages/human-resources/time-management/business/calendar/CalendarDay.ts";
import type { PeriodSummaryRange } from "@/pages/human-resources/time-management/business/analysis/PeriodSummaryRange.ts";
import { useReadCalendarDays } from "@/pages/human-resources/time-management/services/hooks/useReadCalendarDays.ts";
import computeSummaryDates from "@/pages/human-resources/time-management/business/analysis/computeSummaryDates.ts";

export function useReadCalendarDaysForPeriodSummary(
  siteId: string,
  date: Date,
  mode: PeriodSummaryMode,
  range: PeriodSummaryRange,
): CalendarDay[] {
  const dates = computeSummaryDates(date, mode, range);
  return useReadCalendarDays(siteId, dates?.start, dates?.end) ?? [];
}
